import { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  production: true,
  env: 'production',
  auth: {
    host: 'https://auth.erpclass.com.br',
    prefix: '/api/v1/auth',
  },
  api: {
    host: 'https://dash-api.erpclass.com.br',
    prefix: '/api/v1',
  },
  nfe: {
    host: 'https://api.nfeclass.com.br',
    prefix: '/api/v1',
  },
  socket: {
    url: 'https://dash-api.erpclass.com.br',
  },
  social: {
    googleClientId: '998768119258-sl7t42k5mdt114ivg6vv8uh3jtir17lo.apps.googleusercontent.com',
    facebookAppId: '27540909878941769',
  },
};
